// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202601131003/js/" + chunkId + "." + {"44":"4805d063","225":"4eec82c5","481":"26ca24aa","486":"67a5f606","770":"a380d926"}[chunkId] + ".0.14906196150782303.chunk.js";
};